import { createContext } from "react";

export const MenuClose = createContext(null)
export const LanguageSwitch = createContext(null)
